import React from 'react';
import '../../styles/ScoreTrendText.css';

export default function ScoreTrendText() {
  return (
    <div className="score-trend-text">
      <h3>성적 추이 분석</h3>
      <p>
        학생의 성적 변화를 분석한 결과, 전반적으로 안정적인 학습 패턴을 보여주고 있습니다. 
        특히 수학과 과학 과목에서 꾸준한 향상을 보이며, 논리적 사고력과 분석 능력이 우수함을 확인할 수 있습니다.
      </p>
      <p>
        국어와 영어 과목에서는 독해력과 어휘력이 점진적으로 향상되고 있으며, 
        사회 과목에서는 개념 이해와 사고력이 체계적으로 발전하고 있습니다. 
        이러한 성적 추이는 학생이 체계적이고 지속적인 학습 방법을 잘 활용하고 있음을 보여줍니다.
      </p>
      <p>
        향후 학습 방향으로는 강점인 수학·과학 영역을 더욱 심화하고, 
        국어·영어·사회 영역에서는 실전 문제 해결 능력을 향상시키는 것이 좋겠습니다. 
        특히 모의고사 대비를 위한 시간 관리와 문제 유형별 접근법을 연마하면 더욱 좋은 결과를 기대할 수 있습니다.
      </p>
    </div>
  )
}